import '../modal.css';
import { useState} from "react";
import {ModalOrderProps} from "./ModalOrderProps";
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';

export const ModalOrder = (modal: ModalOrderProps) => {
    const [name, setName] = useState('');
    const [phone, setPhone] = useState<any>('');
    const [isAgree, setAgree] = useState(false);
    const [error, setError] = useState<{ name?: string; phone?: string; agree?: string }>({});
    const [title, setTitle] = useState('');

    const resetDataForm = () => {
        setName('');
        setPhone('');
    }

    const validate = () => {

        const newErrors: { name?: string; phone?: string; agree?: string } = {};

        if (!name.trim()) {
            newErrors.name = 'Имя обязательно';
        }

        if (!isAgree){
            newErrors.agree = 'Необходимо согласие на обработку данных';
        }

        setError(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    if (!modal.isOpen) return null;

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setTitle(modal.title);
        modal.onSubmit({ name, phone, title});
        modal.onClose();
        resetDataForm();
    };

    return (
        <div className="modal-overlay">
            <div className="modal-order">
                <button   className="modal-close-button"
                          onClick={modal.onClose}
                          aria-label="Закрыть окно">

                </button>

                <h2 className={'modal__title'}>Оставьте ваши координаты и мы свяжемся с вами в ближайшее время</h2>
                <a className={'contact-phone'} href={'tel:+79632936313'}>+7(963) 293-63-13</a>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="name"></label>
                        <input
                            type="text"
                            id="name"
                            className={'form-input-name input-modal'}
                            value={name}
                            placeholder={'Имя'}
                            onChange={(e) => setName(e.target.value)}
                            required
                        />
                        {error.name && <span className="error">{error.name}</span>}
                    </div>
                    <div className="form-group">
                        <label htmlFor="email"></label>
                        <PhoneInput international
                                    defaultCountry="RU"
                                    value={phone}
                                    onChange={setPhone}></PhoneInput>
                        {error.phone && <span className="error">{error.phone}</span>}
                    </div>
                    <div className="form-group agreement">
                        <label className={'checkbox-modal'}>
                            <input
                                type="checkbox"
                                checked={isAgree}
                                onChange={(e) => setAgree(e.target.checked)}
                            />
                            <span>Я согласен на обработку персональных данных </span>
                        </label>
                        {error.agree && <span className="error">{error.agree}</span>}
                        <div className="phone-attention">
                            Мы не будем использовать ваш номер телефона в рекламных целях
                        </div>
                    </div>
                    <button type="submit" className={'btn-sand'}>Отправить</button>
                </form>
            </div>
        </div>
    )
}